import ApiClientInstance from '../../common/ApiClient';

export const apiGetCategories = (companyId) => ApiClientInstance.get(
  `api/accountants/company/list-categories${companyId ? `?company_id=${companyId}` : ''}`,
  undefined,
  true,
);

export const apiUpdateTransactionCategory = (
  companyId,
  accountId,
  transactionId,
  categoryId,
) => ApiClientInstance.post(
  `api/accountants/company/transaction-category${companyId ? `?company_id=${companyId}` : ''}`,
  {
    account_id: accountId,
    items: [
      {
        transaction_id: transactionId,
        category_id: categoryId,
      },
    ],
  },
  undefined,
  true,
);
